import { __awaiter } from "tslib";
import { LexiWallet } from "@civic/lexi";
import { hash } from "tweetnacl";
export default class EncryptionAdapter {
    constructor(wrappedAdapter, settings) {
        this.wrappedAdapter = wrappedAdapter;
        if (settings instanceof LexiWallet) {
            this.lexiWallet = settings;
        }
        else {
            this.lexiWallet = new LexiWallet(settings.signer, settings.did, {
                publicSigningString: settings.publicSigningString
                    ? Buffer.from(hash(Buffer.from(settings.publicSigningString))).toString("base64")
                    : undefined,
            });
        }
    }
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wrappedAdapter.has(contentId);
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.wrappedAdapter.init();
        });
    }
    set(contentId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            // really naïve integration of lexi, to be replaced TODO
            const encrypted = yield this.lexiWallet.encryptForMe({ content });
            return this.wrappedAdapter.set(contentId, encrypted);
        });
    }
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedResult = yield this.wrappedAdapter.get(contentId);
            if (!encryptedResult)
                return null;
            try {
                const { content } = yield this.lexiWallet.decrypt(encryptedResult);
                return content;
            }
            catch (e) {
                if (e instanceof Error) {
                    if (e.message.indexOf("bad_jwe") !== -1) {
                        return encryptedResult;
                    }
                }
                throw e;
            }
        });
    }
    getWrappedAdapter() {
        return this.wrappedAdapter;
    }
}
